<template>
  <div class="vue-typed-js">
    <slot />
  </div>
</template>

<script>
import Typed from "typed.js";

export default {
  name: "VueTypedJs",
  props: {
    strings: { type: Array, default: () => [] },
    typeSpeed: { type: Number, default: 50 },
    backSpeed: { type: Number, default: 30 },
    loop: { type: Boolean, default: true },
    showCursor: { type: Boolean, default: true },
    smartBackspace: { type: Boolean, default: true },
    attr: { type: String, default: null }
  },
  data() {
    return { typed: null };
  },
  mounted() {
    const el = this.$el.querySelector(".typing") || this.$el.querySelector("input") || this.$el;
    const isInput = el.tagName === "INPUT" || el.tagName === "TEXTAREA";
    // Prefer placeholder typing for inputs so v-model is not polluted
    const attr = this.attr || (isInput ? "placeholder" : null);

    this.typed = new Typed(el, {
      strings: this.strings.length ? this.strings : [el.getAttribute("placeholder") || ""],
      typeSpeed: this.typeSpeed,
      backSpeed: this.backSpeed,
      loop: this.loop,
      showCursor: isInput ? false : this.showCursor,
      smartBackspace: this.smartBackspace,
      attr,
      bindInputFocusEvents: isInput,
      contentType: "null"
    });
  },
  beforeUnmount() {
    if (this.typed) this.typed.destroy();
  }
};
</script>
